import {
    Box,
    Group,
    Stack,
    Title,
    Transition,
    Button,
    Notification,
    Text,
} from "@mantine/core";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {
    clearKaiPlusSuggestionMessage,
    selectActiveThread,
} from "../../threadsSlice";
import classes from "./RegenerationNotifications.module.css";
import {useTranslation} from "react-i18next";
import {KAI_BRAND_BASE} from "../../../../app/theme";
import {
    KAIResponseType,
    LowScoreMessage,
    NoAnswerMessage,
    NoSourcesMessage,
} from "../../../../types";

export function CommonNotification({
    onRegenerate,
    message,
}: {
    onRegenerate: (responseType?: KAIResponseType) => void;
    message: NoSourcesMessage | LowScoreMessage | NoAnswerMessage | undefined;
}) {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const activeThread = useAppSelector(selectActiveThread);
    const handleRegenerate = () => {
        if (!message || !activeThread) {
            return;
        }

        dispatch(
            clearKaiPlusSuggestionMessage({
                id: activeThread.id,
                messageId: message.messageId,
            })
        );
        onRegenerate(KAIResponseType.Deep);
    };

    const handleClose = () => {
        if (!message || !activeThread) {
            return;
        }
        dispatch(
            clearKaiPlusSuggestionMessage({
                id: activeThread.id,
                messageId: message.messageId,
            })
        );
    };
    return (
        <Transition transition="slide-up" mounted={message !== undefined}>
            {(transitionStyles) => (
                <Notification
                    style={{
                        ...transitionStyles,
                    }}
                    className={classes.notification}
                    radius="md"
                    color={"var(--kai-brand-base)"}
                    withCloseButton={false}
                    closeButtonProps={{
                        variant: "subtle",
                        color: "gneis",
                        radius: "xl",
                    }}
                    onClose={handleClose}
                >
                    <Box>
                        <Group
                            align="center"
                            justify="space-between"
                            className={classes.content}
                        >
                            <Stack gap={0} flex={1}>
                                <Title order={3} className={classes.header}>
                                    {t("callout.suggestplus.common.title")}
                                </Title>
                                <Text>
                                    {t("callout.suggestplus.common.text")}
                                </Text>
                            </Stack>
                            <Button
                                variant="filled"
                                size="md"
                                color={"var(--kai-brand-base)"}
                                onClick={handleRegenerate}
                            >
                                {t("callout.suggestplus.common.confirm")}
                            </Button>
                        </Group>
                    </Box>
                </Notification>
            )}
        </Transition>
    );
}
